import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';

const mapBlocks = document.querySelectorAll('.js-interactive-map-block');

// loop through all map blocks
mapBlocks.forEach((block) => {

    mapboxgl.accessToken = block.getAttribute('data-map-box-token');

    const layers = JSON.parse(block.getAttribute('data-layers'));
    let map = {};

    // if map is clicked on and sidebar is closed, open it back up
    function openSidebarIfClosed() {

        /* eslint-disable-next-line */
        if (!Alpine.store('sidebar').open) {

            /* eslint-disable-next-line */
            Alpine.store('sidebar').toggle();
            document.getElementById('js-interactive-sidebar').classList.toggle('!-translate-x-full');

        }

    }

    function deselectRegion() {

        // Hide the active layer info
        document.querySelectorAll('.js-layer-detail').forEach((layerDetail) => {

            layerDetail.classList.add('hidden');

        });

        // show the list view
        document.getElementById('map-layers-list-view').classList.remove('hidden');

        // Reset the fill color of the 'polygons' layer to its default value
        map.setPaintProperty('polygons', 'fill-color', '#a4a5e3');

        // Reset the text color of the 'pointLabel' layer to its default value
        map.setPaintProperty('pointLabel', 'text-color', '#3C40DA');

        /* eslint-disable-next-line */
        openSidebarIfClosed();

    }

    /*
        initialise the map!
    */
    function mapInit() {

        setTimeout(function doMapInit() {

            const isTouchscreen = window.matchMedia('(pointer: coarse)').matches;

            map = new mapboxgl.Map({

                container: block.getAttribute('id'), // container ID
                style: 'https://basemaps.cartocdn.com/gl/voyager-gl-style/style.json', // style URL
                center: [-89.000000, 40.000000], // starting position [lng, lat]
                zoom: 5, // starting zoom
                minZoom: 5,
                scrollZoom: false, // prevent map from zooming when user scrolls
                // prevent map from panning when user scrolls on touchscreens
                cooperativeGestures: isTouchscreen,

            });

            map.addControl(new mapboxgl.NavigationControl());

            const images = {
                /* eslint-disable-next-line */
                'popup': '../_resources/themes/enjoyillinois/images/map/popup.png', // todo for front end dev - please generate a png for label background
                /* eslint-disable-next-line */
                'active_popup': '../_resources/themes/enjoyillinois/images/map/popup_debug.png', // todo for front end dev - please generate a png for active label background
            };

            const features = [];
            /* eslint-disable-next-line */
            layers.map((layer) => {

                const polygon = layer.geoJson;
                polygon.properties = {
                    layerID: layer.htmlID,
                };
                features.push(polygon);
                features.push(layer.labelPoint);

            });

            /* eslint-disable-next-line */
            loadImages(images, (loadedImages) => {

                map.on('load', () => {

                    /* eslint-disable-next-line */
                    for (const name in images) {

                        map.addImage(name, loadedImages[name], {
                            // The two (blue) columns of pixels that can be stretched horizontally:
                            //   - the pixels between x: 25 and x: 55 can be stretched
                            //   - the pixels between x: 85 and x: 115 can be stretched.
                            stretchX: [
                                [25, 55],
                                [85, 115],
                            ],
                            // The one (red) row of pixels that can be stretched vertically:
                            //   - the pixels between y: 25 and y: 100 can be stretched
                            stretchY: [[25, 100]],
                            // This part of the image that can contain text ([x1, y1, x2, y2]):
                            content: [25, 25, 115, 100],
                            // This is a high-dpi image:
                            pixelRatio: 2,
                        });

                    }

                    // adds the polygons to the map
                    map.addSource('placesSource', {
                        /* eslint-disable-next-line */
                        'type': 'geojson',
                        /* eslint-disable-next-line */
                        'data': {
                            /* eslint-disable-next-line */
                            'type': 'FeatureCollection',
                            /* eslint-disable-next-line */
                            'features': features,
                        },
                    });

                    // adds a layer for the polygon fill
                    map.addLayer({
                        /* eslint-disable-next-line */
                        'id': 'polygons',
                        /* eslint-disable-next-line */
                        'type': 'fill',
                        /* eslint-disable-next-line */
                        'source': 'placesSource', // reference the data source
                        /* eslint-disable-next-line */
                        'layout': {},
                        /* eslint-disable-next-line */
                        'paint': {
                            'fill-color': '#a4a5e3', // todo - Fix the Fill color
                            'fill-opacity': 0.5,
                        },
                    });

                    // adds a layer for the outline of the polygon
                    map.addLayer({
                        /* eslint-disable-next-line */
                        'id': 'outline',
                        /* eslint-disable-next-line */
                        'type': 'line',
                        /* eslint-disable-next-line */
                        'source': 'placesSource',
                        /* eslint-disable-next-line */
                        'layout': {},
                        /* eslint-disable-next-line */
                        'paint': {
                            'line-color': '#efefef', // todo - Fix the Line color
                            'line-width': 2,
                        },
                    });

                    // Add a layer for the point label text with a stretched image background
                    map.addLayer({
                        id: 'pointLabel',
                        type: 'symbol',
                        source: 'placesSource',
                        layout: {
                            'icon-image': ['get', 'image_name'],
                            'text-field': ['get', 'name'],
                            'icon-text-fit': 'both',
                            'icon-allow-overlap': true,
                            'text-allow-overlap': true,
                        },
                        paint: {
                            'text-color': '#3C40DA', // todo - Fix the Text color
                        },
                    });

                    const bounds = new mapboxgl.LngLatBounds();
                    /* eslint-disable-next-line */
                    layers.map((layer) => {

                        const coordinates = layer.geoJson.geometry.coordinates[0];
                        for (const coordinate of coordinates) {

                            bounds.extend(coordinate);

                        }

                    });

                    map.fitBounds(bounds, {
                        padding: 20,
                    });

                    map.on('click', 'polygons', (e) => {

                        const layerID = e.features[0].properties.layerID;
                        /* eslint-disable-next-line */
                        showLayerInfo(layerID);

                    });

                    map.on('click', 'pointLabel', (e) => {

                        const layerID = e.features[0].properties.layerID;
                        /* eslint-disable-next-line */
                        showLayerInfo(layerID);

                    });

                    // handle map click outside regions
                    map.on('click', (e) => {

                        const renderedFeatures = map.queryRenderedFeatures(e.point, { layers: ['polygons'] });

                        if (renderedFeatures.length === 0) {

                            deselectRegion();

                        }

                    });

                    map.on('mouseenter', 'polygons', () => {

                        map.getCanvas().style.cursor = 'pointer';

                    });

                    map.on('mouseleave', 'polygons', () => {

                        map.getCanvas().style.cursor = '';

                    });

                });

            });

        }, 0);

    }

    document.querySelectorAll('.js-map-list-item').forEach((layer) => {

        layer.addEventListener('click', () => {

            const layerID = layer.getAttribute('data-layer-id');
            /* eslint-disable-next-line */
            showLayerInfo(layerID);

        });

    });

    function showLayerInfo(layerID) {

        // reset the fill color for all polygons
        map.setPaintProperty('polygons', 'fill-color', '#a4a5e3');

        // reset the text color for all labels
        map.setPaintProperty('pointLabel', 'text-color', '#3C40DA');
        // map.setLayoutProperty('pointLabel', 'icon-image', ['get', 'image_name']);

        // Hide the region list and show the region info
        document.getElementById('map-layers-list-view').classList.add('hidden');
        document.querySelectorAll('.js-layer-detail').forEach((layerDetail) => {

            layerDetail.classList.add('hidden');

        });

        document.getElementById(layerID).classList.remove('hidden');

        // Change the fill color for the clicked polygon
        map.setPaintProperty('polygons', 'fill-color', ['match', ['get', 'layerID'], layerID, '#3C40DA', '#a4a5e3']);

        // Change the text color for the related label
        map.setPaintProperty('pointLabel', 'text-color', ['match', ['get', 'layerID'], layerID, '#3C40DA', '#a4a5e3']);

        // todo - change the icon image for the related label

        /* eslint-disable-next-line */
        openSidebarIfClosed();

    }

    function loadImages(urls, callback) {

        const results = {};

        /* eslint-disable-next-line */
        for (const name in urls) {

            /* eslint-disable-next-line */
            map.loadImage(urls[name], makeCallback(name));

        }

        function makeCallback(name) {

            return (err, image) => {

                results[name] = err ? null : image;

                if (Object.keys(results).length === Object.keys(urls).length) {

                    callback(results);

                }

            };

        }

    }

    // Add event listeners to all back buttons
    const backButtons = document.querySelectorAll('.back-btn');
    backButtons.forEach((button) => {

        button.addEventListener('click', () => {

            deselectRegion();

        });

    });

    mapInit();

});
